import React from 'react';
import PropTypes from 'prop-types';
import { useManagedQuery } from 'utils/managedHooks';

import Spinner from 'admin-components/components/Spinner';
import { userShape } from 'constants/propTypes';
import { Row, Column } from 'components/shared/Layout';
import { useDefaultedCurrencyFromURL } from 'utils/hooks/currency';
import { getAssistances, getValidExtras } from 'utils/booking';
import { GET_EXTRAS } from 'store/queries';
import { GET_BOOKING } from './graphql';
import { StyledStickyContainer } from '../BookingDetails.styles';
import BookingDetailsTable from '../BookingDetailsTable';
import ModuleTabs from '../ModuleTabs';

import Payments from './Payments';

const PaymentsContainer = ({ user, bookingCurrency, isMultiCurrency, reference }) => {
  const [currency] = useDefaultedCurrencyFromURL({
    availableCurrencies: user.paymentCurrencies,
    defaultCurrency: bookingCurrency,
    isMultiCurrency
  });

  const { data, loading } = useManagedQuery(GET_BOOKING, {
    variables: { reference, currency },
    fetchPolicy: 'network-only'
  });

  const { data: dataExtras } = useManagedQuery(GET_EXTRAS, {
    variables: { reference }
  });

  if (loading) {
    return (
      <Row span={16} height="100vh">
        <Column justifyContent="center" alignItems="center">
          <Spinner />
        </Column>
      </Row>
    );
  }

  const { booking } = data;

  const journeyExtras = dataExtras && [...dataExtras.booking.outboundExtras, ...dataExtras.booking.inboundExtras];
  const assistances = journeyExtras && getAssistances(journeyExtras);

  const filteredExtras = dataExtras && [
    ...getValidExtras(dataExtras.booking.outboundExtras),
    ...getValidExtras(dataExtras.booking.insurances),
    ...getValidExtras(dataExtras.booking.hotels),
    ...getValidExtras(dataExtras.booking.inboundExtras),
    ...getValidExtras(dataExtras.booking.travelPassProducts)
  ];

  return (
    <>
      <StyledStickyContainer id="booking-details">
        <BookingDetailsTable booking={booking} />
        <ModuleTabs
          notes={booking.notes}
          reference={booking.reference}
          outbound={booking.nonExchangedOutbound}
          inbound={booking.nonExchangedInbound}
          assistances={assistances}
          extras={filteredExtras}
          booking={booking}
        />
      </StyledStickyContainer>
      <Payments currency={currency} loading={loading} booking={booking} user={user} />
    </>
  );
};

PaymentsContainer.propTypes = {
  reference: PropTypes.string.isRequired,
  isMultiCurrency: PropTypes.bool.isRequired,
  bookingCurrency: PropTypes.string.isRequired,
  user: userShape.isRequired
};

export default PaymentsContainer;
